// extracted by mini-css-extract-plugin
export var actionIcon = "_oj-0";